<template>
    <div>
        <div class="expanded-sidebar-footer" :class="{ 'hidden': sidenavIsCollapsed }">
            <div v-if="user.organization_applications.length > 0" class="bg-navy border-t border-navy-light flex justify-center py-4 space-x-5">
                <template v-for="(organizationApplication, index) in user.organization_applications">
                    <div v-if="organizationApplication.application.slug === 'crm'"
                        @click="connectToApplication(index)"
                        class="bg-purple-500 flex h-6 cursor-pointer duration-300 transform hover:scale-150 items-center justify-center rounded-full w-6"
                        v-tooltip="{ content: $t('globals.access_application', { application: organizationApplication.application.name }) }"
                        style="padding: 0.35rem;">
                        <svg class="block fill-current h-6 text-white w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M8 24l3-9h-9l14-15-3 9h9l-14 15z"></path>
                        </svg>
                    </div>
                    <div v-if="organizationApplication.application.slug === 'tasks'"
                        @click="connectToApplication(index)"
                        class="bg-red-500 flex h-6 cursor-pointer duration-300 transform hover:scale-150 items-center justify-center rounded-full w-6"
                        v-tooltip="{ content: $t('globals.access_application', { application: organizationApplication.application.name }) }"
                        style="padding: 0.35rem;">
                        <svg class="block fill-current h-6 text-white w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M4.967 15c-2.743 0-4.967-2.238-4.967-5 0-2.761 2.224-5 4.967-5h5.033v10h-5.033zm7.04 7.475c-.52-.424-.902-.994-1.095-1.637l-1.151-3.827h-5.125l1.905 5.883c.214.659.828 1.106 1.521 1.106h3.439c.358 0 .677-.225.797-.562.12-.337.015-.713-.263-.939l-.028-.024zm-.007-17.475v10c3.164.509 7.161 1.992 12 5v-20c-4.964 3.085-8.876 4.502-12 5z"></path>
                        </svg>
                    </div>
                    <div v-if="organizationApplication.application.slug === 'budgets'"
                        @click="connectToApplication(index)"
                        v-tooltip="{ content: $t('globals.access_application', { application: organizationApplication.application.name }) }"
                        class="bg-blue-500 flex h-6 cursor-pointer duration-300 transform hover:scale-150 items-center justify-center rounded-full w-6"
                        style="padding: 0.35rem;">
                        <svg class="block fill-current text-white" style="height: 10px; width: 10px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M5 19h-4v-4h4v4zm6 0h-4v-8h4v8zm6 0h-4v-13h4v13zm6 0h-4v-19h4v19zm1 2h-24v2h24v-2z"></path>
                        </svg>
                    </div>
                </template>
            </div>
            <div class="navbar navbar-default">
                <div class="navbar-header">
                    <a href="/" class="flex font-thin items-center navbar-brand navbar-brand-center text-white text-lg tracking-wide">
                        <div class="bg-white flex h-6 items-center justify-center mr-3 rounded-full w-6" style="padding: 0.2rem;">
                            <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><circle cx="256" cy="256" fill="#fff" r="256" data-original="#1CE8B7" data-old_color="#1ce8b7"/><path d="M511.822 265.084L314.851 68.113l.739 25.654-26.879-26.879-60.497 106.817-78.762 53.541 33.234 33.234-20.357 28.699-52.697-52.697 20.744 97.745-26.661 37.585 139.887 139.887c4.108.193 8.24.301 12.398.301 138.343 0 251.036-109.741 255.822-246.916z" fill="#f7fafc" data-original="#1DCC9E" data-old_color="#1dcc9e"/><path d="M431.726 301.68l-37.304-33.293-14.914 16.711-18.698-35.489-44.236 23.306 27.397 52.001-10.625 11.905-44.635 12.201v-67.377l76.658-50.621 41.038 7.273 8.726-49.233-28.634-5.074 8.694-26.623-47.529-15.522-17.051 52.213-41.902 27.669v-70.849l56.438-42.991-30.298-39.774-26.14 19.911V66.887h-65v92.646l-52.083-51.93-35.303 35.408 22.545 22.478-33.016 17.675 23.599 44.081 46.427-24.855 27.831 27.749v91.568l-53.416-13.142 29.447-48.238-42.677-26.052-20.866 34.182-26.567-31.977-38.459 31.952 40.633 48.908-22.145 6.485 14.054 47.985 52.206-15.29 67.79 16.677v57.096h65v-29.437l59.805-16.347 72.249 11.209 7.665-49.409-32.091-4.979z" fill="#74d9e7" data-original="#FF6155" data-old_color="#ff6155"/><path d="M431.726 301.68l-37.304-33.293-14.914 16.711-18.698-35.489-44.236 23.306 27.397 52.001-10.625 11.905-44.635 12.201v-67.377l76.658-50.621 41.038 7.273 8.726-49.233-28.634-5.074 8.694-26.623-47.529-15.522-17.051 52.213-41.902 27.669v-70.849l56.438-42.991-30.298-39.774-26.14 19.911V66.887h-33.116v363.406h33.116v-29.437l59.805-16.347 72.249 11.209 7.665-49.409-32.091-4.979z" fill="#38c8dd" data-original="#ED2415" class="active-path" data-old_color="#ed2415"/></svg>
                        </div>
                        Reefkig
                    </a>
                </div>
            </div>
        </div>
        <div class="collapsed-sidebar-footer" :class="{ 'hidden': ! sidenavIsCollapsed }">
            <div v-if="user.organization_applications.length > 0" class="bg-navy border-t border-navy-light flex flex-col items-center py-4 space-y-4">
                <template v-for="(organizationApplication, index) in user.organization_applications">
                    <div v-if="organizationApplication.application.slug === 'crm'"
                        @click="connectToApplication(index)"
                        class="bg-purple-500 flex h-6 cursor-pointer duration-300 transform hover:scale-150 items-center justify-center rounded-full w-6"
                        v-tooltip="{ content: $t('globals.access_application', { application: organizationApplication.application.name }) }"
                        style="padding: 0.35rem;">
                        <svg class="block fill-current h-6 text-white w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M8 24l3-9h-9l14-15-3 9h9l-14 15z"></path>
                        </svg>
                    </div>
                    <div v-if="organizationApplication.application.slug === 'tasks'"
                        @click="connectToApplication(index)"
                        class="bg-red-500 flex h-6 cursor-pointer duration-300 transform hover:scale-150 items-center justify-center rounded-full w-6"
                        v-tooltip="{ content: $t('globals.access_application', { application: organizationApplication.application.name }) }"
                        style="padding: 0.35rem;">
                        <svg class="block fill-current h-6 text-white w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M4.967 15c-2.743 0-4.967-2.238-4.967-5 0-2.761 2.224-5 4.967-5h5.033v10h-5.033zm7.04 7.475c-.52-.424-.902-.994-1.095-1.637l-1.151-3.827h-5.125l1.905 5.883c.214.659.828 1.106 1.521 1.106h3.439c.358 0 .677-.225.797-.562.12-.337.015-.713-.263-.939l-.028-.024zm-.007-17.475v10c3.164.509 7.161 1.992 12 5v-20c-4.964 3.085-8.876 4.502-12 5z"></path>
                        </svg>
                    </div>
                    <div v-if="organizationApplication.application.slug === 'budgets'"
                        @click="connectToApplication(index)"
                        v-tooltip="{ content: $t('globals.access_application', { application: organizationApplication.application.name }) }"
                        class="bg-blue-500 flex h-6 cursor-pointer duration-300 transform hover:scale-150 items-center justify-center rounded-full w-6"
                        style="padding: 0.35rem;">
                        <svg class="block fill-current text-white" style="height: 10px; width: 10px;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                            <path d="M5 19h-4v-4h4v4zm6 0h-4v-8h4v8zm6 0h-4v-13h4v13zm6 0h-4v-19h4v19zm1 2h-24v2h24v-2z"></path>
                        </svg>
                    </div>
                </template>
            </div>
            <div class="bg-primary-500 flex items-center justify-center" style="min-height: 60px">
                <a href="/">
                    <div class="bg-white flex h-6 items-center justify-center rounded-full w-6" style="padding: 0.2rem;">
                        <svg class="h-6 w-6" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><circle cx="256" cy="256" fill="#fff" r="256" data-original="#1CE8B7" data-old_color="#1ce8b7"/><path d="M511.822 265.084L314.851 68.113l.739 25.654-26.879-26.879-60.497 106.817-78.762 53.541 33.234 33.234-20.357 28.699-52.697-52.697 20.744 97.745-26.661 37.585 139.887 139.887c4.108.193 8.24.301 12.398.301 138.343 0 251.036-109.741 255.822-246.916z" fill="#f7fafc" data-original="#1DCC9E" data-old_color="#1dcc9e"/><path d="M431.726 301.68l-37.304-33.293-14.914 16.711-18.698-35.489-44.236 23.306 27.397 52.001-10.625 11.905-44.635 12.201v-67.377l76.658-50.621 41.038 7.273 8.726-49.233-28.634-5.074 8.694-26.623-47.529-15.522-17.051 52.213-41.902 27.669v-70.849l56.438-42.991-30.298-39.774-26.14 19.911V66.887h-65v92.646l-52.083-51.93-35.303 35.408 22.545 22.478-33.016 17.675 23.599 44.081 46.427-24.855 27.831 27.749v91.568l-53.416-13.142 29.447-48.238-42.677-26.052-20.866 34.182-26.567-31.977-38.459 31.952 40.633 48.908-22.145 6.485 14.054 47.985 52.206-15.29 67.79 16.677v57.096h65v-29.437l59.805-16.347 72.249 11.209 7.665-49.409-32.091-4.979z" fill="#74d9e7" data-original="#FF6155" data-old_color="#ff6155"/><path d="M431.726 301.68l-37.304-33.293-14.914 16.711-18.698-35.489-44.236 23.306 27.397 52.001-10.625 11.905-44.635 12.201v-67.377l76.658-50.621 41.038 7.273 8.726-49.233-28.634-5.074 8.694-26.623-47.529-15.522-17.051 52.213-41.902 27.669v-70.849l56.438-42.991-30.298-39.774-26.14 19.911V66.887h-33.116v363.406h33.116v-29.437l59.805-16.347 72.249 11.209 7.665-49.409-32.091-4.979z" fill="#38c8dd" data-original="#ED2415" class="active-path" data-old_color="#ed2415"/></svg>
                    </div>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        sidenavIsCollapsed: {
            type: Boolean,
            required: true,
        },
        user: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            form: new Form({
                organization_application_user_id: '',
                session_data: null,
            }),
            applicationInstance: null,
            applicationForm: new Form({
                user_id: '',
                token: '',
            }),
        };
    },

    computed: {
        sessionData() {
            return window.Globals.sessionData ?? [];
        },
    },

    methods: {
        connectToApplication(index) {
            const organizationApplication = this.user.organization_applications[index];
            this.form.organization_application_user_id = organizationApplication.pivot.id;
            this.form.session_data = this.sessionData;

            Globals.post('/api/v1/authentication-token', this.form)
                .then(response => {
                    this.applicationInstance = axios.create({ baseURL: organizationApplication.application.url, withCredentials: true });
                    this.applicationForm.user_id = response.user_access.user_id;
                    this.applicationForm.token = response.token;
                })
                .then(() => this.applicationInstance.post('/login', this.applicationForm))
                .then(() => window.location.href = organizationApplication.application.url)
                .catch(error => {
                    const errors = this.form.errors.any() ? this.form.errors.flatten() : this.applicationForm.errors.flatten();
                    const message = errors.length > 0 ? errors[0] : this.$t('globals.unexpected_error');
                    window.toastr.clear();
                    window.toastr.error(message);
                })
                .finally(() => {
                    this.resetForms();
                    this.closeDropdown();
                    this.applicationInstance = null;
                });
        },

        resetForms() {
            this.form = new Form({
                organization_application_user_id: '',
                session_data: null,
            });
            this.applicationForm = new Form({
                user_id: '',
                token: '',
            });
        },
    },
};
</script>
